// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kR9k0PRBQ5wjDHdTAxPl{padding:10px}.ts_Oi7DKhxcHjkxswo5m{color:var(--gray-60);justify-content:center;padding:8.5px 0;font-size:12px;font-weight:400;line-height:15px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `kR9k0PRBQ5wjDHdTAxPl`,
	"noResult": `ts_Oi7DKhxcHjkxswo5m`
};
export default ___CSS_LOADER_EXPORT___;
